import { MaskedLine } from "./Reveal";
import { SiteImg } from "../hooks/useSiteImages";

export const PageHero = ({ overline, title, accent, subtitle, image, slot }) => (
    <section
        className="noise relative flex min-h-[62vh] items-end overflow-hidden"
        data-testid="page-hero"
    >
        <div className="absolute inset-0">
            <SiteImg
                slot={slot}
                fallback={image}
                alt=""
                className="h-full w-full object-cover"
                loading="eager"
            />
            <div className="absolute inset-0 bg-black/60" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-black/40" />
        </div>
        <div className="relative mx-auto w-full max-w-7xl px-6 pb-20 pt-44 lg:px-10">
            <p className="mb-6 font-mono text-xs uppercase tracking-[0.35em] text-brand">
                {overline}
            </p>
            <h1 className="hero-shadow max-w-4xl font-display text-[clamp(2.4rem,6vw,5rem)] font-black uppercase leading-[0.98] tracking-tight">
                <MaskedLine delay={0.1}>{title}</MaskedLine>
                {accent && (
                    <MaskedLine delay={0.25}>
                        <span className="text-brand">{accent}</span>
                    </MaskedLine>
                )}
            </h1>
            {subtitle && (
                <p className="mt-8 max-w-xl text-base text-zinc-300 md:text-lg">
                    {subtitle}
                </p>
            )}
        </div>
    </section>
);
